import { queryKeys } from 'config/queryKeys'
import { routes } from 'config/routes'
import { useMutation, useQueryClient } from 'libs/query'
import { useNavigate, useParams } from 'libs/router'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

export const useEditAreaTypeMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: editAreaTypeMutation, isPending: isEditAreaTypeLoading } = useMutation({
		mutationFn: (data: FormData) => {
			// TODO: change to apiRoutes
			return axiosPrivate.patch(`/booth-types/${params.id}/`, data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.boothTypes.all })
			useToast({ type: 'success', message: t('Area type updated') })()

			navigate(routes.areaTypeIndex)
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editAreaTypeMutation,
		isEditAreaTypeLoading
	}
}
